import { Menu, MenuButton, MenuItems } from "@headlessui/react";
import React, { Fragment } from "react";
import OpenChangeObserver from "./OpenChangeObserver";

interface DropdownMenuProps {
  trigger: React.ReactNode;
  children: React.ReactNode;
  onOpenChange?: (open: boolean) => void;
  className?: string;
}

export default function DropdownMenu({
  trigger,
  children,
  onOpenChange,
  className = "",
}: DropdownMenuProps) {
  return (
    <Menu
      as="div"
      className={`relative inline-block min-w-0 text-left ${className}`}
    >
      {({ open }) => (
        <>
          <OpenChangeObserver open={open} onOpenChange={onOpenChange} />
          <MenuButton as={Fragment}>{trigger}</MenuButton>
          <MenuItems
            anchor={{ to: "bottom start", gap: 4, padding: 8 }}
            portal
            transition
            className="z-[150] w-48 max-w-[calc(100vw-16px)] overflow-y-auto rounded-md border border-neutral-700 bg-neutral-800 py-1 shadow-lg outline-none transition-opacity duration-100 data-[closed]:opacity-0"
          >
            {children}
          </MenuItems>
        </>
      )}
    </Menu>
  );
}
